import { useComments } from '../../context/CommentsProvider';
import { useSettings } from '../../context/SettingsProvider';
import CommentsTree from './CommentsTree';

export default function CommentsRoot() {
  const settings = useSettings();
	const commentsContext = useComments();
  const rootItems = typeof commentsContext.comments[0] !== "undefined" && typeof commentsContext.comments[0].children !== "undefined" ? commentsContext.comments[0].children : [];
  
  return (
    <ul className={settings.isLoading ? "comments--root is-loading" : "comments--root"}>
      {rootItems.map(id => (
        <CommentsTree
          key={id}
          id={id}
          parentId={0}
          comments={commentsContext.comments}
        />
      ))}
    </ul>
  );
}